import { GetUser } from "@redotech/redo-model/user";
import { createContext } from "react";

export const UserCacheContext = createContext<Map<string, GetUser>>(new Map());
